import React, { useEffect, useState } from "react";
import { Col, Dropdown, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import { Link } from "react-router-dom";
import classnames from "classnames";
import bell from "../../assets/images/svg/bell.svg";
import config from "../../config";
import * as url from '../../helpers/url_helper';
const apiUrl = config[config.status].apiUrl;
//SimpleBar
import SimpleBar from "simplebar-react";
import { useProfile } from "../../Components/Hooks/UserHooks";
import { createSelector } from "reselect";
import { setUnseenNotifications } from "../../slices/auth/menu/reducer";
import { useDispatch, useSelector } from "react-redux";
import { sendNotificationSeen } from "../../slices/auth/menu/thunk";

const NotificationDropdown = () => {
	const dispatch = useDispatch();
	const { token, userId } = useProfile();

	const selectStates = createSelector(state => state, state => ({
		notifications: state.MenuData.notifications,
		unseenNotifications: state.MenuData.unseenNotifications,
		user: state.Login.user,
	}));
	const { notifications, unseenNotifications, user } = useSelector(selectStates);
	
	//Dropdown Toggle	
	const [isNotificationDropdown, setIsNotificationDropdown] = useState(false);
	const toggleNotificationDropdown = () => {
		setIsNotificationDropdown(!isNotificationDropdown);
	};

	//Tab 
	const [activeTab, setActiveTab] = useState("1");
	const toggleTab = (tab) => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	useEffect(() => {
		if (isNotificationDropdown && unseenNotifications > 0) {
			dispatch(sendNotificationSeen(notifications.map(item => item._id)));
		}
	}, [isNotificationDropdown]);

	return (
		<React.Fragment>
			<Dropdown isOpen={isNotificationDropdown} toggle={toggleNotificationDropdown} className="topbar-head-dropdown ms-1 header-item">
				<DropdownToggle type="button" tag="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle">
					<i className='bx bx-bell fs-22'></i>
					{unseenNotifications ?
						<span
							className="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">{unseenNotifications}<span
								className="visually-hidden">unread messages</span></span>
						: null}
				</DropdownToggle>
				<DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
					<div className="dropdown-head bg-primary bg-pattern rounded-top">
						<div className="p-3">
							<Row className="align-items-center">
								<Col>
									<h6 className="m-0 fs-16 fw-semibold text-white"> Notifications </h6>
								</Col>
								<div className="col-auto dropdown-tabs">
									{unseenNotifications ?
										<span className="badge fs-13"> {unseenNotifications} New</span>
										: null}
								</div>
							</Row>
						</div>

						{/* <div className="px-2 pt-2">
							<Nav className="nav-tabs dropdown-tabs nav-tabs-custom">
								<NavItem>
									<NavLink
										href="#"
										className={classnames({ active: activeTab === "1" })}
										onClick={() => { toggleTab("1"); }}
									>
										All {notifications && `(${notifications.length})` }
									</NavLink>
								</NavItem>
								<NavItem>
									<NavLink
										href="#"
										className={classnames({ active: activeTab === "2" })}
										onClick={() => { toggleTab("2"); }}
									>
										Messages
									</NavLink>
								</NavItem>
								<NavItem>
									<NavLink
										href="#"
										className={classnames({ active: activeTab === "3" })}
										onClick={() => { toggleTab("3"); }}
									>
										Alerts
									</NavLink>
								</NavItem>
							</Nav>
						</div> */}

					</div>

					<TabContent activeTab={activeTab}>
						<TabPane tabId="1" className={unseenNotifications > 2 ? "ps-2 py-2" : "p-2 py-2"}>

							{notifications.length === 0 ?
								<React.Fragment>
									<div className="w-25 w-sm-50 pt-3 mx-auto">
										<img src={bell} className="img-fluid" alt="user-pic" />
									</div>
									<div className="text-center pb-5 mt-2">
										<h6 className="fs-18 fw-semibold lh-base">Hey! You have no any notifications </h6>
									</div>
								</React.Fragment>
								: notifications.map((item, idx) => {
									return (
										<React.Fragment key={idx}>
											<div className="notification-item d-block text-reset dropdown-item position-relative" >
												<div className="d-flex align-items-center">
													<div className="avatar-xs me-3 flex-shrink-0">
														{item.type === 'system' ?
															<span className="avatar-title bg-info-subtle text-info rounded-circle fs-16">
																<i className="bx bx-badge-check"></i>
															</span>
														: null}
													</div>
													<div className="flex-grow-1">
														<a className="stretched-link" href={item.link} target="_blank">
															<h6 className="m-0 lh-base">{item.message}</h6>
														</a>
													</div>
												</div>
											</div>
										</React.Fragment>
									)
								})
							}
						</TabPane>

						{/* <TabPane tabId="2" className="p-4">
							<div className="w-25 w-sm-50 pt-3 mx-auto">
								<img src={bell} className="img-fluid" alt="user-pic" />
							</div>
							<div className="text-center pb-5 mt-2">
								<h6 className="fs-18 fw-semibold lh-base">Hey! You have no any notifications </h6>
							</div>
						</TabPane>
						<TabPane tabId="3" className="p-4">
							<div className="w-25 w-sm-50 pt-3 mx-auto">
								<img src={bell} className="img-fluid" alt="user-pic" />
							</div>
							<div className="text-center pb-5 mt-2">
								<h6 className="fs-18 fw-semibold lh-base">Hey! You have no any notifications </h6>
							</div>
						</TabPane> */}
					</TabContent>
				</DropdownMenu>
			</Dropdown>
		</React.Fragment>
	);
};

export default NotificationDropdown;